export default {
  services: "Services",
  AddServices: "AddServices",
  editServices: "EditServices",
};
